import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';

import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSliderModule } from '@angular/material/slider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatDividerModule } from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatMenuModule } from '@angular/material/menu';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatBadgeModule } from '@angular/material/badge';
import { MatChipsModule } from '@angular/material/chips';
import { MatTreeModule } from '@angular/material/tree';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import { MatRadioModule } from '@angular/material/radio';
import { MatNativeDateModule } from '@angular/material/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {MatTableModule} from '@angular/material/table';

const modules = [
  MatCheckboxModule,
  MatDatepickerModule,
  MatSliderModule,
  MatFormFieldModule,
  MatSelectModule,
  MatTabsModule,
  MatSidenavModule,
  MatBottomSheetModule,
  MatToolbarModule,
  MatButtonModule,
  MatIconModule,
  MatDialogModule,
  MatInputModule,
  MatDividerModule,
  MatListModule,
  MatCardModule,
  MatTooltipModule,
  MatGridListModule,
  MatMenuModule,
  MatSlideToggleModule,
  MatExpansionModule,
  MatNativeDateModule,
  MatRadioModule,
  MatBadgeModule,
  MatChipsModule,
  MatTreeModule,
  MatProgressSpinnerModule,
  MatProgressSpinnerModule,
  MatSnackBarModule,
  MatTableModule,
  MatButtonToggleModule,
  


];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    [...modules]
  ],
  exports: [
    [...modules]

  ],
  providers: [
    MatDatepickerModule,
  ],
})
export class MaterialModule { }


